import { store } from '@wordpress/interactivity'

import { STORE_NAMESPACE } from '../../modules/default-store';


store( STORE_NAMESPACE, {} )